import {
  StepType,
  type TutorialEntry,
  type WizardConfig,
} from '@thyme/nashville/src/components/thymeWizard/types'

const MY_QUEUE_TUTORIAL: WizardConfig = {
  id: 'my-queue-v1',
  title: 'My Queue',
  steps: [
    {
      type: StepType.Modal,
      content: {
        title: 'Welcome to My Queue',
        description:
          'Your daily workspace for managing care tasks. This tour will walk you through your schedule, your assigned members, and how to pick up unassigned work.',
      },
    },
    {
      type: StepType.Tooltip,
      anchorIdSuffix: 'schedule',
      content: {
        title: 'Your Daily Schedule',
        description:
          'Your upcoming scheduled calls for today appear here. Click any event to open the call details.',
      },
    },
    {
      type: StepType.Tooltip,
      anchorIdSuffix: 'assigned-table',
      content: {
        title: 'Your Assigned Members',
        description:
          "These are the members assigned to you for today. Each row shows a member's care tier, preferred language, and the subtasks that need your attention.",
      },
    },
    {
      type: StepType.Tooltip,
      anchorIdSuffix: 'unassigned-table',
      content: {
        title: 'Unassigned Members',
        description:
          "Members here have outstanding tasks but haven't been assigned to a care team member yet. You can pick them up to add them to your queue.",
      },
    },
    {
      type: StepType.Tooltip,
      anchorIdSuffix: 'assign-all',
      content: {
        title: 'Assign a Member to Yourself',
        description:
          "Click 'Assign All' to take ownership of a member's subtasks and move them into your assigned queue above.",
      },
    },
    {
      type: StepType.Modal,
      content: {
        title: "You're All Set!",
        description:
          'You now know the key parts of My Queue. Revisit this tour anytime by clicking the pulsing dot near your daily schedule.',
      },
    },
  ],
}

export const wizardConfigs: TutorialEntry[] = [{ config: MY_QUEUE_TUTORIAL }]
